import { CSSObject } from 'libs/ui/styled';
import { Theme } from 'libs/ui/theme';

import { ButtonColorVariant } from '../types';

import { getStandardMode } from './standard';

export const getStandardSmallMode = (
  theme: Theme,
  colorVariant: ButtonColorVariant
): CSSObject => ({
  ...getStandardMode(theme, colorVariant),
  height: 42,
  paddingLeft: 16,
  paddingRight: 16,

  '&': {
    [theme.breakpoints.down('mobile')]: {
      height: 36,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
});
